// Shared sx for the Credits page, matching the customer dashboard's cards.
// xs is a phone here (see the dashboard mobile pass), so xs values are phone
// sizes and the desktop ladder starts at sm.

export const INK = '#08231B';
export const MUTED = '#6b7470';
export const BORDER = '#E9EBE9';
export const TRACK = '#ececea';
export const SOFT = '#F7F8F6';
export const DANGER = '#c62828';

export const cardSx = {
  backgroundColor: '#ffffff',
  border: `1px solid ${BORDER}`,
  borderRadius: '14px',
  boxShadow: '0 1px 2px rgba(8,35,27,0.04)',
  p: { xs: '16px', md: '20px 22px' },
  fontFamily: 'Rubik',
  minWidth: 0,
};

export const titleSx = {
  fontFamily: 'Rubik',
  fontWeight: 700,
  letterSpacing: '-0.01em',
  fontSize: { xs: '17px', sm: '16px', lg: '18px', xl: '20px' },
  color: INK,
  lineHeight: 1.25,
};

export const headingSx = {
  fontFamily: 'Rubik',
  fontWeight: 600,
  fontSize: { xs: '14px', sm: '13px', lg: '14px', xl: '15px' },
  color: INK,
  mb: 1,
};

// Uppercase section label, as on the dashboard's usage tiles.
export const eyebrowSx = {
  fontFamily: 'Rubik',
  fontSize: { xs: '11px', xl: '12px' },
  fontWeight: 700,
  color: MUTED,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

export const captionSx = {
  fontFamily: 'Rubik',
  fontSize: { xs: '12px', sm: '11px', lg: '12px', xl: '13px' },
  color: MUTED,
  lineHeight: 1.45,
};

export const bodySx = {
  fontFamily: 'Rubik',
  fontSize: { xs: '13px', sm: '12px', lg: '13px', xl: '14px' },
  color: '#111613',
};

export const buttonSx = {
  fontFamily: 'Rubik',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: { xs: '13px', sm: '12px', xl: '13px' },
  borderRadius: '8px',
  boxShadow: 'none',
  minHeight: { xs: 38, sm: 34 },
  px: 2,
  whiteSpace: 'nowrap',
  '&:hover': { boxShadow: 'none' },
};

export const outlinedButtonSx = {
  ...buttonSx,
  color: INK,
  borderColor: BORDER,
  backgroundColor: '#fff',
  '&:hover': { borderColor: '#cfd3cf', backgroundColor: SOFT },
};

export const dangerButtonSx = {
  ...buttonSx,
  color: DANGER,
  '&:hover': { backgroundColor: 'rgba(198,40,40,0.06)' },
};

export const inputSx = {
  '& .MuiOutlinedInput-root': {
    fontFamily: 'Rubik',
    fontSize: { xs: '14px', sm: '13px' },
    borderRadius: '8px',
    backgroundColor: '#fff',
    '& fieldset': { borderColor: BORDER },
    '&:hover fieldset': { borderColor: '#cfd3cf' },
  },
  '& .MuiInputLabel-root': { fontFamily: 'Rubik', fontSize: { xs: '14px', sm: '13px' } },
};

// Small rounded label, e.g. a card's mode or a deal's source.
export const pillSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  px: 1.25,
  py: 0.25,
  borderRadius: '99px',
  border: `1px solid ${BORDER}`,
  backgroundColor: SOFT,
  fontFamily: 'Rubik',
  fontSize: { xs: '12px', sm: '11px', xl: '12px' },
  fontWeight: 500,
  color: INK,
  whiteSpace: 'nowrap',
};

export const barTrackSx = {
  height: 8,
  borderRadius: '99px',
  backgroundColor: TRACK,
  '& .MuiLinearProgress-bar': { borderRadius: '99px' },
};

export const sectionSx = { borderTop: `1px solid ${BORDER}`, pt: 2.5, mt: 2.5 };
